import { Component, inject, input, OnInit, viewChild } from '@angular/core';

import { MultiVinErrorModalComponent } from '../../../shared/ui/modals/multi-vin-error-modal/multi-vin-error-modal.component';
import { ClearMissingVinsAndStocknumbers, Configuration, MultiSearchMode } from 'remarketing-angular-library';
import { takeUntil } from 'rxjs';
import { Store } from '@ngxs/store';
import { TranslocoService } from '@jsverse/transloco';
import { SaComponent } from 'smartauction-frontend-micro-library';

@Component({
  selector: 'app-multi-vin-error',
  templateUrl: './multi-vin-error.component.html',
  styleUrl: './multi-vin-error.component.scss',
  imports: [MultiVinErrorModalComponent],
  standalone: true
})
export class MultiVinErrorComponent extends SaComponent implements OnInit {
  readonly multiVinErrorModal$ = viewChild<MultiVinErrorModalComponent>(MultiVinErrorModalComponent);
  readonly vins$ = input<string[]>();
  readonly stockNumbers$ = input<string[]>();

  multiSearchMode = MultiSearchMode;
  private readonly store: Store;
  private readonly translocoService: TranslocoService;
  configuration: Configuration;
  translations = {
    textCouldntFind: '',
    textVIN: '',
    textStockUnit: '',
    textContactHelp: '',
    btnSeeMore: '',
    btnCloseError: '',
    altCloseErrorIcon: ''
  };

  constructor() {
    super();
    this.store = inject(Store);
    this.translocoService = inject(TranslocoService);
  }

  ngOnInit() {
    this.getTranslations();

    this.store
    .select(_state => _state.configuration.configuration)
    .pipe(takeUntil(this.destroyed$))
    .subscribe(_configuration => (this.configuration = _configuration));
  }

  closeError() {
    this.store.dispatch(new ClearMissingVinsAndStocknumbers());
  }

  showModal() {
    this.multiVinErrorModal$().show();
  }

  getTranslations() {
    const keyParams = {
      'sellModule.manageInventory.multiVinError': {},
      common: {}
    };

    this.translocoService
    .selectTranslateObject(keyParams)
    .pipe(takeUntil(this.destroyed$))
    .subscribe(translation => {
      this.translations.textCouldntFind = translation[0].textCouldntFind;
      this.translations.textVIN = translation[0].textVIN;
      this.translations.textStockUnit = translation[0].textStockUnit;
      this.translations.textContactHelp = translation[0].textContactHelp;
      this.translations.btnCloseError = translation[0].btnCloseError;
      this.translations.altCloseErrorIcon = translation[0].altCloseErrorIcon;
      this.translations.btnSeeMore = translation[1].btnSeeMore;
    });
  }

  get type(): MultiSearchMode | null {
    return this.vins$()?.length ? MultiSearchMode.VIN :
      this.stockNumbers$()?.length ? MultiSearchMode.STOCK :
        null;
  }

  get missingItems(): string[] | null {
    return this.vins$()?.length ? this.vins$() :
      this.stockNumbers$()?.length ? this.stockNumbers$() :
        null;
  }

}
